import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {DateTime, NavController, NavParams} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {HotspotService} from "../../../providers/hotspot-service";
import {
    TMonth,
    TAction,
    TFinanceSide,
    TWeekday,
    TRuleValue,
    TGeradorFlag,
    TGeradorLine,
    TPaybookFato,
    TPrecifyMenu,
    TClusterTipo,
    TProdutoView,
} from "../../../app/enum";
import {TFilterOpera} from "../../../pipes/filter-field/filter-field";
import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {ModalFieldPage} from "../modal-field/modal-field";
import {ModalActionPage} from "../modal-action/modal-action";
import {ProdutoMenuPage} from "../produto-menu/produto-menu";
import {PaybookFindPage} from "../paybook-find/paybook-find";
import {WebstorOpenPage} from "../webstor-open/webstor-open";

@Component({
    selector: 'page-gerador-menu',
    templateUrl: 'gerador-menu.html',
    providers: [HotspotService]
})
export class GeradorMenuPage {

    TFilterOpera: any = TFilterOpera;

    //Contrato - etapa 0
    TGeradorFlag: any = TGeradorFlag;
    TGeradorLine: any = TGeradorLine;
    TFinanceSide: any = TFinanceSide;
    TPaybookFato: any = TPaybookFato;

    TMonth: any = TMonth;

    //Servico - etapa 1
    TRuleValue: any = TRuleValue;

    config: any;
    logado: any;
    perfil: any;

    etapa: number;

    copyrat: any;
    rootrat: any;

    rootspot: any;
    copyspot: any;

    @ViewChild(DateTime) iondate: DateTime;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util,
                public logadoService: LogadoService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.navParams.get('perfil');

        this.etapa = this.navParams.get('etapa');
        this.rootrat = this.navParams.get('rootrat');
        this.copyrat = this.navParams.get('copyrat');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        let contratoID = this.navParams.get('contratoID');

        /* Google Analytics */
        let title = (this.etapa == 1 ? 'Serviço' : 'Info');
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Contrato - ' + title, '/webstor/gerador-menu/' + title.toLowerCase());

        if (contratoID) this.contratLoad(contratoID);

    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    profilePush() {

        /** MENU **/
        let object = {profileSpot: false, profileID: this.copyrat.Profile.ProfileID, rootile: null};
        this.util.modalopen(ProfileMenuPage, 'alto', false, object).subscribe();

    }

    paybookFind() {

        let object = {etapa: 1, userset: null, hotspotID: this.copyspot.Hotspots[0].HotspotID, geradorID: this.copyrat.ContratoID, profile: this.copyspot.Hotspots[0].Empresas[0], profileID: 0};
        this.util.modalopen(PaybookFindPage, 'alto', false, object).subscribe();

    }



    /** *********************************************** CONTRATO ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    contratLoad(contratoID) {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.contrato(TAction.acLoad, contratoID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!data.Contratos || !data.Contratos.length) return;

                    this.rootrat = data.Contratos[0];
                    this.copyrat = this.util.deepCopy(this.rootrat);

                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                });

    }

    contratSave(that: any = null, novo: boolean = false) {


        //EXCLUIR-CONTRATO
        if (novo && this.copyrat.Projeto.ProjetoID == 1004 && !this.rootrat.ContratoID) {
            this.util.alertSimply('Informe o ContratoID');
            return;
        }


        //Contrato novo somente com botão!
        if (!novo && !this.copyrat.ContratoID) {
            if (that) that.dismiss();
            if (this.etapa == 1) this.dismiss();
            return;
        }

        //EXCLUIR-CONTRATO
        if (this.copyrat.Projeto.ProjetoID == 1004 && !this.copyrat.ContratoID) this.copyrat.ContratoID = this.rootrat.ContratoID;

        let json = this.copyrat;

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.contrato(TAction.acSave, this.copyrat.ContratoID, 0, this.copyrat.HotspotID, this.copyrat.ContratoFlag, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    //Hotspot exibe status do contrato
                    if (!this.copyrat.ContratoID) this.copyrat.ContratoID = data.Codigo;

                    let delidx = -1;
                    this.copyrat.Servicos.forEach((servico, index) => {
                        if (!servico.ServicoID) servico.ServicoID = data.Codigo;
                        if (servico._deleted) delidx = index;
                    });

                    if (delidx >= 0) this.copyrat.Servicos.splice(delidx, 1);

                    if (this.rootspot) {
                        this.rootspot.Hotspots[0].Contrato = {ContratoID: this.copyrat.ContratoID, ContratoFlag: this.copyrat.ContratoFlag};
                        this.copyspot.Hotspots[0].Contrato = {ContratoID: this.copyrat.ContratoID, ContratoFlag: this.copyrat.ContratoFlag};
                    }

                    this.util.populateObj(this.rootrat, this.copyrat);
                    if (that) that.dismiss();

                },
                erro => {
                    this.copyrat.Servicos.forEach(servico => delete servico._deleted);
                    if (this.copyrat.ContratoID) this.util.populateObj(this.copyrat, this.rootrat);
                    this.util.alertResult(erro);
                });

    }

    contratLixo() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.contrato(TAction.acLixo, this.copyrat.ContratoID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (this.rootspot) {
                        this.rootspot.Hotspots[0].Contrato = null;
                        this.copyspot.Hotspots[0].Contrato = null;
                    }

                    this.dismiss();

                },
                erro => {
                    this.util.alertPopula(erro, this.rootrat, this.copyrat);
                });

    }

    devedorMail() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.contrato(TAction.acMail, this.copyrat.ContratoID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.dismiss(),
                erro => this.util.alertResult(erro));

    }

    contratHide() {

        let onOkey = (okey, that) => {

            //Seleciona o Motivo
            let onSave = (rule) => {

                this.copyspot.Hotspots[0].Contrato.ContratoFlag = rule;
                let json = this.copyspot.Hotspots[0].Contrato;

                let loading = this.util.loadingDots();
                loading.present();

                this.hotspotService.contrato(TAction.acHide, json.ContratoID, 0, this.copyspot.Hotspots[0].HotspotID, json.ContratoFlag, json)
                    .finally(() => loading.dismiss())
                    .subscribe(
                        data => {

                            this.util.populateObj(this.rootspot, this.copyspot);
                            this.navCtrl.popToRoot();

                        },
                        erro => {
                            this.util.alertPopula(erro, this.rootspot, this.copyspot);
                        });

            };

            /** OPEN **/
            let buttons: Array<any> = [];
            let arrayEnum = this.util.enumArray(TGeradorFlag, TGeradorFlag.ctFechou);
            arrayEnum.forEach(rule => buttons.push({text: rule.slice(2, 99), handler: () => onSave(TGeradorFlag[rule])}));
            this.util.sheetOpen(buttons, 'MOTIVO');

        };

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'assinatura', onOkey)};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    contratWork() {

        let onSave = (rule) => {
            this.copyrat.ContratoFlag = rule;
            this.contratSave();
        };

        let onStop = () => {

            /** OPEN **/
            let arrayEnum = this.util.enumArray(TGeradorFlag, TGeradorFlag.ctFechou);
            let buttons: Array<any> = [];
            arrayEnum.forEach(rule => buttons.push({text: rule.slice(2, 99), handler: () => onSave(TGeradorFlag[rule])}));
            this.util.sheetOpen(buttons, 'MOTIVO');

        };

        if (this.copyrat.ContratoFlag == TGeradorFlag.ctAberto) {

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Parado',    handler: () => onSave(TGeradorFlag.ctParado)});
            buttons.push({text: 'Cancelado', handler: () => onStop()});
            this.util.sheetOpen(buttons, 'STATUS');

        }

        if (this.copyrat.ContratoFlag == TGeradorFlag.ctParado) {

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Aberto',    handler: () => onSave(TGeradorFlag.ctAberto)});
            buttons.push({text: 'Cancelado', handler: () => onStop()});
            this.util.sheetOpen(buttons, 'STATUS');

        }

        if (this.copyrat.ContratoFlag > TGeradorFlag.ctParado) {

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Aberto', handler: () => onSave(TGeradorFlag.ctAberto)});
            buttons.push({text: 'Parado', handler: () => onSave(TGeradorFlag.ctParado)});
            this.util.sheetOpen(buttons, 'STATUS');

        }

    }

    contratQtde() {

        let onQtde = (qtde) => {
            this.copyrat.ContratoQtde = qtde;
            this.contratSave();
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Indefinido', value: 0});
        for (let i = 1; i <= 200; i++) buttons.push({text: this.util.plural(i, 'parcela'), value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = 0;
        this.util.pickerOpen(columns, onQtde);

    }

    contratWhen() {

        let onSave = (rule) => {
            this.copyrat.ContratoFato = rule;
            this.contratSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TPaybookFato);
        let buttons: Array<any> = [];
        arrayEnum.forEach(rule => buttons.push({text: rule.slice(2, 99), handler: () => onSave(TPaybookFato[rule])}));
        this.util.sheetOpen(buttons, 'COMPETÊNCIA');

    }

    contratFlug(flug: 'tint' | 'dayz' | 'mesz') {

        if (flug == 'tint') {
            if (this.copyrat.ContratoFlag == TGeradorFlag.ctAberto) return 'CorMato';
            if (this.copyrat.ContratoFlag == TGeradorFlag.ctParado) return 'CorWeek';
            if (this.copyrat.ContratoFlag >= TGeradorFlag.ctFechou) return 'CorFood';
        }

        if (flug == 'dayz' && this.copyrat.ContratoDayz) {
            if (this.copyrat.ContratoGera == TGeradorLine.glSemana)     return TWeekday[this.copyrat.ContratoDayz].slice(2, 99);
            if (this.copyrat.ContratoGera == TGeradorLine.glQuinze)     return 'Dia ' + (this.copyrat.ContratoDayz <= 15 ? this.copyrat.ContratoDayz : this.copyrat.ContratoDayz -15) + ' e ' + (this.copyrat.ContratoDayz <= 15 ? this.copyrat.ContratoDayz +15 : this.copyrat.ContratoDayz);
            if (this.copyrat.ContratoGera == TGeradorLine.glMensal)     return 'Dia ' + this.copyrat.ContratoDayz;
            if (this.copyrat.ContratoGera == TGeradorLine.glBimestral)  return 'Dia ' + this.copyrat.ContratoDayz;
            if (this.copyrat.ContratoGera == TGeradorLine.glTrimestral) return 'Dia ' + this.copyrat.ContratoDayz;
            if (this.copyrat.ContratoGera == TGeradorLine.glSemestral)  return 'Dia ' + this.copyrat.ContratoDayz;
            if (this.copyrat.ContratoGera == TGeradorLine.glAnual)      return 'Dia ' + this.copyrat.ContratoDayz;
        }

        if (flug == 'mesz' && this.copyrat.ContratoGera == TGeradorLine.glBimestral) {
            if (this.copyrat.ContratoMoon == TMonth.mnJaneiro)   return 'Jan • Mar • Mai • Jul • Set • Nov';
            if (this.copyrat.ContratoMoon == TMonth.mnFevereiro) return 'Fev • Abr • Jun • Ago • Out • Dez';
        }

        if (flug == 'mesz' && this.copyrat.ContratoGera == TGeradorLine.glTrimestral) {
            if (this.copyrat.ContratoMoon == TMonth.mnJaneiro)   return 'Jan • Abr • Jul • Out';
            if (this.copyrat.ContratoMoon == TMonth.mnFevereiro) return 'Fev • Mai • Ago • Nov';
            if (this.copyrat.ContratoMoon == TMonth.mnMarco)     return 'Mar • Jun • Set • Dez';
        }

        if (flug == 'mesz' && this.copyrat.ContratoGera == TGeradorLine.glSemestral) {
            if (this.copyrat.ContratoMoon == TMonth.mnJaneiro)   return 'Jan • Jul';
            if (this.copyrat.ContratoMoon == TMonth.mnFevereiro) return 'Fev • Ago';
            if (this.copyrat.ContratoMoon == TMonth.mnMarco)     return 'Mar • Set';
            if (this.copyrat.ContratoMoon == TMonth.mnAbril)     return 'Abr • Out';
            if (this.copyrat.ContratoMoon == TMonth.mnMaio)      return 'Mai • Nov';
            if (this.copyrat.ContratoMoon == TMonth.mnJunho)     return 'Jun • Dez';
        }

        if (flug == 'mesz' && this.copyrat.ContratoGera == TGeradorLine.glAnual) {
            return TMonth[this.copyrat.ContratoMoon].slice(2, 99);
        }

        return '';

    }

    contratTime() {

        let onNext = (time) => {

            let onNoxt = (noxt) => {

                let timo = this.copyrat.ContratoGera;
                let zera = (!this.copyrat.ContratoDayz || timo <= TGeradorLine.glQuinze || time <= TGeradorLine.glQuinze);
                if (zera) this.contratDayz(time, noxt);
                if (!zera) {
                    this.copyrat.ContratoGera = time;
                    this.copyrat.ContratoMoon = noxt;
                }

            };

            if (time == TGeradorLine.glNenhum)  {
                this.copyrat.ContratoGera = time;
                this.contratSave();
                return;
            }

            if (time == TGeradorLine.glMensal || time == TGeradorLine.glSemana)  {
                onNoxt(TMonth.mnJaneiro);
                return;
            }

            if (time == TGeradorLine.glBimestral)  {
                /** OPEN **/
                let buttons: Array<any> = [];
                buttons.push({text: 'Jan • Mar • Mai • Jul • Set • Nov', handler: () => onNoxt(TMonth.mnJaneiro)});
                buttons.push({text: 'Fev • Abr • Jun • Ago • Out • Dez', handler: () => onNoxt(TMonth.mnFevereiro)});
                this.util.sheetOpen(buttons, 'BIMESTRAL');
                return;
            }

            if (time == TGeradorLine.glTrimestral) {
                /** OPEN **/
                let buttons: Array<any> = [];
                buttons.push({text: 'Jan • Abr • Jul • Out', handler: () => onNoxt(TMonth.mnJaneiro)});
                buttons.push({text: 'Fev • Mai • Ago • Nov', handler: () => onNoxt(TMonth.mnFevereiro)});
                buttons.push({text: 'Mar • Jun • Set • Dez', handler: () => onNoxt(TMonth.mnMarco)});
                this.util.sheetOpen(buttons, 'TRIMESTRAL');
                return;
            }

            if (time == TGeradorLine.glSemestral) {
                /** OPEN **/
                let buttons: Array<any> = [];
                buttons.push({text: 'Jan • Jul', handler: () => onNoxt(TMonth.mnJaneiro)});
                buttons.push({text: 'Fev • Ago', handler: () => onNoxt(TMonth.mnFevereiro)});
                buttons.push({text: 'Mar • Set', handler: () => onNoxt(TMonth.mnMarco)});
                buttons.push({text: 'Abr • Out', handler: () => onNoxt(TMonth.mnAbril)});
                buttons.push({text: 'Mai • Nov', handler: () => onNoxt(TMonth.mnMaio)});
                buttons.push({text: 'Jun • Dez', handler: () => onNoxt(TMonth.mnJunho)});
                this.util.sheetOpen(buttons, 'SEMESTRAL');
                return;
            }

            if (time == TGeradorLine.glAnual) {
                /** OPEN **/
                let buttons: Array<any> = [];
                buttons.push({text: 'Jan', handler: () => onNoxt(TMonth.mnJaneiro)});
                buttons.push({text: 'Fev', handler: () => onNoxt(TMonth.mnFevereiro)});
                buttons.push({text: 'Mar', handler: () => onNoxt(TMonth.mnMarco)});
                buttons.push({text: 'Abr', handler: () => onNoxt(TMonth.mnAbril)});
                buttons.push({text: 'Mai', handler: () => onNoxt(TMonth.mnMaio)});
                buttons.push({text: 'Jun', handler: () => onNoxt(TMonth.mnJunho)});
                buttons.push({text: 'Jul', handler: () => onNoxt(TMonth.mnJulho)});
                buttons.push({text: 'Ago', handler: () => onNoxt(TMonth.mnAgosto)});
                buttons.push({text: 'Set', handler: () => onNoxt(TMonth.mnSetembro)});
                buttons.push({text: 'Out', handler: () => onNoxt(TMonth.mnOutubro)});
                buttons.push({text: 'Nov', handler: () => onNoxt(TMonth.mnNovembro)});
                buttons.push({text: 'Dez', handler: () => onNoxt(TMonth.mnDezembro)});
                this.util.sheetOpen(buttons, 'ANUAL');
                return;
            }

        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TGeradorLine);
        let buttons: Array<any> = [];
        arrayEnum.forEach(rule => buttons.push({text: rule.slice(2, 99), handler: () => onNext(TGeradorLine[rule])}));
        this.util.sheetOpen(buttons, 'TIME');

    }

    contratDayz(time?, noxt?) {

        let onSave = (dayz) => {
            if (time) {
                this.copyrat.ContratoGera = time;
                this.copyrat.ContratoMoon = noxt;
            }
            this.copyrat.ContratoDayz = dayz;
            this.copyrat.ContratoBase = this.util.dateToStr(null);
            this.contratSave();
        };

        if (!time) time = this.copyrat.ContratoGera;

        if (time == TGeradorLine.glSemana) {
            /** OPEN **/
            let arrayEnum = this.util.enumArray(TWeekday);
            let buttons: Array<any> = [];
            arrayEnum.forEach(week => buttons.push({text: week.slice(2, 99), handler: () => onSave(TWeekday[week])}));
            this.util.sheetOpen(buttons, 'WEEKDAY');
        }

        if (time != TGeradorLine.glSemana) {
            /** OPEN **/
            let buttons: Array<any> = [];
            for (let i = 1; i <= 30; i++) buttons.push({text: i + 'º', value: i});

            let columns = [];
            columns.push({name: 'root', options: buttons});
            columns[0].selectedIndex = this.copyrat.ContratoDayz -1;
            this.util.pickerOpen(columns, onSave);
        }

    }

    contratUser(done?) {

        if (!done && this.copyrat.ContratoUser) {

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Abrir site',   handler: () => this.util.open(this.copyrat.ContratoLink, '_blank', '')});
            buttons.push({text: 'Editar login', handler: () => this.contratUser(true)});
            this.util.sheetOpen(buttons, 'STATUS');
            return;

        }

        let onOkiy = (that, okiy, index, isLast) => {

            this.copyrat.ContratoLink = okiy[0].groups[0].fields[0].value;
            this.copyrat.ContratoUser = okiy[0].groups[1].fields[0].value;
            this.copyrat.ContratoPswd = okiy[0].groups[2].fields[0].value;
            this.contratSave(that);

        };


        let fieldLink = this.config.modalField(TFieldType.ftLine, 'Link', null, null, this.copyrat.ContratoLink, null, null);
        let groupLink = this.config.modalGroup(null, [fieldLink]);

        let fieldName = this.config.modalField(TFieldType.ftLine, 'User', null, null, this.copyrat.ContratoUser, null, null);
        let groupName = this.config.modalGroup(null, [fieldName]);

        let fieldPass = this.config.modalField(TFieldType.ftLine, 'Senha', null, null, this.copyrat.ContratoPswd, null, null);
        let groupPass = this.config.modalGroup(null, [fieldPass]);

        let slideFull = this.config.modalSlide('Acesso', null, 'Acesso', 'b-icon-key-1', 'CorRoxa', [groupLink, groupName, groupPass]);

        this.util.modalopen(ModalFieldPage, 'quad', true, {slides: [slideFull], onOkiy: onOkiy}).subscribe();

    }

    negocioMenu() {

        if (this.rootspot) {
            this.util.alertSimply('Contrato de Hotspot não pode modificar negócio.');
            return;
        }

    }

    projetoMenu() {

        if (this.rootspot) {
            this.util.alertSimply('Contrato de Hotspot não pode modificar projeto.');
            return;
        }

        let onSave = (array) => {
            this.copyrat.Projeto = array[0];
            this.contratSave();
        };

        let objectPrj = {homeb: false, etapa: 0, title: null, keyname: 'Projeto', toggler: 'many', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, objectPrj).subscribe(data => onSave(data));

    }



    /** ************************************************* SERVIÇO ************************************************* **/
    /** ************************************************* etapa-1 ************************************************* **/

    servicoLixo(event, line) {

        this.util.alertObserv('DELETE', 'Deseja excluir o serviço?', 'Continuar').subscribe(
            () => {

                if (!line.ServicoID) {
                    let index = this.copyrat.Servicos.indexOf(line);
                    this.copyrat.Servicos.splice(index, 1);
                    return;
                }
                line._deleted = true;
                this.contratSave();

            },
            () => {

                //Volter se cancelou processamento!
                event.cancelOverslide();

            });

    }

    servicoCria() {

        let object = {etapa: 1, servicoBool: true, clusterTipo: TClusterTipo.clService, clusters: null, indexes: null, rootspot: this.rootspot, themedep: null, produtoFull: true, produtoView: TProdutoView.pdPrecify, precifyMenu: TPrecifyMenu.pcNormal};
        this.util.modalopen(ProdutoMenuPage, 'alto', false, object).subscribe(
            data => this.servicoCash(null, data.Blended));

    }

    servicoCash(line, blended) {

        let onOkey = (okey, that, data) => {
            if (!line) line = {ServicoID: 0, ServicoCash: 0, ServicoCoin: 0, ServicoQtde: 0, ServicoCare: '', ServicoReju: '', ServicoRule: TRuleValue.rvRulePorc, ServicoRate: 0, ServicoBase: TMonth.mnNenhum, ServicoText: '', Blended: blended};
            line.ServicoCash = this.util.currency(okey.inputf.text);
            if (blended) this.copyrat.Servicos.push(line);
            this.contratSave(that);
        };

        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'servico', onOkey, null, true, 'SERVIÇO')};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    servicoCare(line) {

        let onSave = (root, ruut) => {

            let onOkey = (okey, that, data) => {
                line.ServicoCare = ruut;
                line.ServicoQtde = root;
                line.ServicoCoin = this.util.currency(okey.inputf.text);
                this.contratSave(that);
            };

            let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'servico', onOkey, null, true, 'CARÊNCIA')};
            this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        for (let i = 1; i <= 12; i++) buttons.push({text: i + 'x', value: i});

        let hoje = this.util.dateHoje();
        let buttuns: Array<any> = [];
        for (let i = 0; i <= 5; i++) {
            let date = new Date(hoje.getFullYear(), hoje.getMonth() + i, 1);
            let text = this.util.dateToStr(date);
            buttuns.push({text: this.util.dataft(text, null), value: text});
        }

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns.push({name: 'ruut', options: buttuns});
        columns[0].selectedIndex = 0;
        columns[1].selectedIndex = 0;
        this.util.pickerOpen(columns, onSave, null, null, 1, 0, 'início');

    }

    servicoRule(line) {

        let onSave = (root, ruut) => {

            let onOkey = (okey, that, data) => {
                line.ServicoRule = root;
                line.ServicoRate = this.util.currency(okey.inputf.text);
                line.ServicoBase = ruut;
                this.contratSave(that);
            };

            let bool = (root == TRuleValue.rvRuleReal);
            let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'servico', onOkey, null, bool, 'REAJUSTE')};
            this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

        };

        let buttons: Array<any> = [];
        buttons.push({text: '%',  value: TRuleValue.rvRulePorc});
        buttons.push({text: 'R$', value: TRuleValue.rvRuleReal});

        let buttuns: Array<any> = [];
        buttuns.push({text: 'Jan',  value: TMonth.mnJaneiro});
        buttuns.push({text: 'Fev',  value: TMonth.mnFevereiro});
        buttuns.push({text: 'Mar',  value: TMonth.mnMarco});
        buttuns.push({text: 'Abr',  value: TMonth.mnAbril});
        buttuns.push({text: 'Mai',  value: TMonth.mnMaio});
        buttuns.push({text: 'Jun',  value: TMonth.mnJunho});
        buttuns.push({text: 'Jul',  value: TMonth.mnJulho});
        buttuns.push({text: 'Ago',  value: TMonth.mnAgosto});
        buttuns.push({text: 'Set',  value: TMonth.mnSetembro});
        buttuns.push({text: 'Out',  value: TMonth.mnOutubro});
        buttuns.push({text: 'Nov',  value: TMonth.mnNovembro});
        buttuns.push({text: 'Dez',  value: TMonth.mnDezembro});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns.push({name: 'ruut', options: buttuns});
        columns[0].selectedIndex = 0;
        columns[1].selectedIndex = 0;
        this.util.pickerOpen(columns, onSave);

    }

    dismiss(done?) {

        if (!done && !this.copyrat.ContratoID) {
            let alerta = 'Deseja sair sem criar o contrato?';
            this.util.alertQuestion('ATENÇÃO', alerta, 'Sim|Não', () => this.dismiss(true), false, true, null, null);
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/gerador-menu/gerador-menu.ts